module.exports = __webpack_public_path__ + "static/media/Icon-add.55bea247.svg";